import script from "./LeadsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeadsContent.vue?vue&type=script&setup=true&lang=ts"

import "./LeadsContent.vue?vue&type=style&index=0&id=2787f305&scoped=true&lang=css"
import "./LeadsContent.vue?vue&type=style&index=1&id=2787f305&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2787f305"]])

export default __exports__